import React, { useEffect, useState } from 'react';
import TabsComponent from "../../components/common/tabs";
import BannersComponent from "../../components/common/banner";
import { GetCacheKey } from '../../services/common/utils';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import Loadingcomponent from '../../components/loader/loadingcomponent';
import ErrorMessage from '../../components/messaging/errormessage';
import SearchErrorHandler from '../../components/common/search-error-handler';
import { useLocation } from 'react-router-dom';
import OfferList from '../../components/loader/skeletons/common/offer-list';

const RoamingRatesComponent = ({ pmsitem }) => {
    const { t } = useTranslation()
    const [search, setSearch] = useState("");
    const [filteredContent, setFilteredContent] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredCategory, setFilteredCategory] = useState([]);
    const [content, setContent] = useState([]);
    const {state} = useLocation();
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError,
        isSuccess
    } = useQuery([GetCacheKey("Roaming-Rates"), pmsitem.method, JSON.parse(pmsitem.sourceid), {}], {
        retry: false,
        retryOnMount: true,
        cacheTime: 30000,
        staleTime: 30000
    });
    useEffect(() => {
        if (isSuccess) {
            if (search?.length) {
                const _content = JSON.parse(JSON.stringify(content));
                const result = _content
                    ?.filter(
                        (item) =>
                            item?.data?.filter((item2) =>
                                item2?.country?.toLowerCase()?.includes(search?.toLowerCase())
                            )?.length
                    )
                    ?.map((item, index) => {
                        item.data = item?.data?.filter((item2) =>
                            item2?.country?.toLowerCase()?.includes(search?.toLowerCase())
                        );
                        return item;
                    });
                const result2 = categories?.filter(
                    (item) => result?.filter((item2) => item2?.id === item?.id)?.length
                );
                setFilteredCategories(result2);
                setFilteredContent(result);
            } else {
                setCategories(data?.response?.category);
                setContent(data?.response?.data);
            }
        }
    }, [search, isSuccess]);

    if (isLoading || isFetching) {
        return (
            // <Loadingcomponent message={"Loading"} />
            <OfferList hideFilter={true} countyList={true} />
        );
    }

    if (error || isError || isLoadingError) {
        return <div class="body_container">

            <section class="">
                <div class="bottom_bg_section">
                    <div class="bottom_bg_section_container">
                        <img src="assets/images/assets_bg.jpg" alt="" />
                    </div>
                </div>
                <div class="center_section">
                    <div class="sec_top mt-160">
                        <div class="pse_md">
                            <div class="text-center mb-5">
                                <div class="mb-5">
                                    <picture>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                    </picture>
                                </div>
                                <div>
                                    <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                    <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    }
    return <div className=''>
        <div className='radius_section'>
            <div className="flex_grp_align_center search_input_grp">
                <div className="input_icon_search left-icon flex1">
                    <input type="text" onChange={(e) => setSearch(e.target.value)} maxLength={10} className="form-control" placeholder=""></input>
                    <button className='pe-none'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/search_dark.svg'} alt="" title="" />
                    </button>
                </div>
                {/* <button className='filter_btn'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/fillter-icon.svg'} alt="" title="" />
                    {t("Filter")}
                </button> */}
            </div>
            {(search ? (filteredContent.length > 0 ? <TabsComponent type={7} data={search ? filteredContent : data?.response?.data}></TabsComponent> : <SearchErrorHandler text={t("wcf")} />) : <TabsComponent type={7} data={search ? filteredContent : data?.response?.data}></TabsComponent>)}

        </div>
    </div>

}
export default RoamingRatesComponent;